import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Footer from './Components/Footer';
import Header from './Components/Header';
import Home from './Components/Home';
import Login from './Components/Login/Login';
import { UserStorage } from './UserContext';
import ProtectedRoute from './Components/Helper/ProtectedRoute';
import User from './Components/User/User';
import NotFound from './Components/NotFound';
// import ListarPdvs from './Components/Requests/ListarPdvs';
// import ListarUsuarios from './Components/Requests/ListarUsuarios';
// import AdicionarCads from './Components/Requests/AdicionarCads';
import GerarCsv from './Components/Requests/GerarCsv';
import HistoricoDeEstacionamento from './Components/Requests/HistoricoDeEstacionamento';

const App = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <UserStorage>
          <Header />
          <main className="AppBody">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="login/*" element={<Login />} />
              <ProtectedRoute path="admin/*" element={<User />} />
              {/* <ProtectedRoute path="admin/pdvs" element={<ListarPdvs />} />
              <ProtectedRoute path="admin/users" element={<ListarUsuarios />} /> */}
              <ProtectedRoute path="admin/gerarCsv" element={<GerarCsv />} />
              <ProtectedRoute
                path="admin/historicoDeEstacionamento"
                element={<HistoricoDeEstacionamento />}
              />
              {/* <ProtectedRoute
                path="admin/addCADs"
                element={<AdicionarCads />}
              /> */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </UserStorage>
      </BrowserRouter>
    </div>
  );
};

export default App;
